import { computed, unref, type MaybeRef } from "vue"
import { RegistrationAction } from "@/model/championship/registration-action"
import { type RegistrationActor, type RegistrationPermissions } from "./championship-registration"

const emptyPolicy = Object.freeze(
    Object.fromEntries(
        Object.values(RegistrationAction).map(action => [action, false]),
    ) as Record<RegistrationAction, boolean>,
)

export function useRegistrationPolicy(
    permissions: MaybeRef<RegistrationPermissions | undefined>,
    actor: MaybeRef<RegistrationActor>,
) {
    return computed<Record<RegistrationAction, boolean>>(() => {
        const values = unref(permissions)?.[unref(actor)]

        if (!values) {
            return emptyPolicy
        }

        return {
            ...emptyPolicy,
            ...values,
        }
    })
}
